module.exports = __webpack_public_path__ + "static/img/ssssdfds-322232332-4334334-4343434343.e8f21223.png";